export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14789.42b17840.jpg";